import {
    AllOrdersPage,
    AllUsersPage,
    AppPaths,
    AuthnObserver, AutomatedIfPresetScalesPage,
    CartPage,
    defaultUiConfig,
    EncoderTrackingPage,
    FluorescentHairpinTrackingPage,
    getWithAuthn,
    GOOGLE_ANALYTICS_ID,
    InventoryPage,
    LogInPage,
    LogOutPage,
    ManualBufferTrackingPage,
    ManualStarterKitForm,
    MarketingReferralsPage,
    NewChromogenKitPage,
    NewKitPage,
    NewManualGoldIfKitPage,
    NewManualProConsumerKitPage, NewMultiPlexProKitPage,
    NewRegistrationPage,
    NewRnaFishKitPage,
    NewSecondaryIfKitPage,
    OrderUploadPoPage,
    ProbeLotTablePage,
    ProDetectTrackingPage,
    ProfilePage,
    ProStarterKitForm,
    ReportsPage,
    ResetPasswordPage,
    RnaCatalogPage,
    SecondaryIfProbeTrackingPage,
    ShopLink,
    ShopRedirect,
    SingleOrderPage,
    SingleUserPage,
    StarterKitsPage,
    TrackingPage,
    UiConfig,
    UiConfigContext,
    UserOrderListPage,
    UserOrderPage,
    VerifyEmailPage
} from "@web-ui/common";
import * as React from 'react';
import {Redirect, RouteComponentProps, RouterProps, useLocation} from "react-router";
import {BrowserRouter as Router, Link, NavLink, Route, Switch} from 'react-router-dom';
import {Dropdown, Icon, Menu} from "semantic-ui-react";
import logoImg from './images/hcrimaging_logo.png';
import imagingLogo from './images/imaging-the-molecules-of-life.png'
import linkedinIcon from './images/linkedin-hcr-grey.svg';
import miLogo from './images/mi-logo-final_Black.png';
import twitterIcon from './images/twitter-hcr-grey.svg';
import youtubeIcon from './images/youtube-hcr-grey.svg'

class App extends React.Component<{}, AppState> {

    private readonly authnObserver = new AuthnObserver(() => {
        this.setState({
            uiConfig: defaultUiConfig()
        }, () => this.loadUiConfig())
    });

    constructor(props: {}) {
        super(props);

        this.state = {
            uiConfig: defaultUiConfig()
        }
    }

    public componentDidMount(): void {
        this.loadUiConfig()
    }

    public render() {
        const admin = this.state.uiConfig.uiFeatures.has(FEATURE_SHOW_ADMIN_MENU);
        const reports = this.state.uiConfig.uiFeatures.has(FEATURE_REPORTS);

        return <React.StrictMode>
            <UiConfigContext.Provider value={this.state.uiConfig}>
                <Router>
                    <div className="App">
                        <div className={'above-header'}/>
                        <header>
                            {/*<h1 className={'mi-branded-banner'}>*/}
                            {/*    <strong>Weather Update:</strong> Winter storms are impacting shipping and may cause delays.*/}
                            {/*</h1>*/}
                            {admin &&
                                <div>
                                    <Menu
                                        className={'admin-menu'}
                                        floated={'right'}
                                    >
                                        <Dropdown
                                            item={true}
                                            text={'Admin'}
                                            labeled={true}
                                            simple={true}
                                        >
                                            <Dropdown.Menu
                                                direction={'left'}
                                            >
                                                <Dropdown.Item as={this.renderAllOrdersLink}/>
                                                <Dropdown.Item as={this.renderAllUsersLink}/>
                                                <Dropdown.Item as={this.renderTrackingLink}/>
                                                <Dropdown.Item as={this.renderRnaCatalogLink}/>
                                                <Dropdown.Item as={this.renderProbeLotTable}/>
                                                <Dropdown.Item as={this.renderInventoryLink}/>
                                                <Dropdown.Item as={this.renderStarterKitsLink}/>
                                                <Dropdown.Item as={this.renderReferralsLink}/>
                                                <Dropdown.Item as={this.renderAutomatedIfPresetReagentScalesLink}/>
                                                {reports &&
                                                    <Dropdown.Item as={this.renderReportsLink}/>}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </Menu>
                                </div>
                            }

                            <nav>
                                <div className={'left'}>
                                    <a style={{padding: '0'}} href={"https://www.hcrimaging.com"}>
                                        <img src={logoImg} alt={'logo'} className={'logo'}/>
                                    </a>
                                </div>

                                <div className={'center'}>
                                    <a
                                        style={{fontSize: '18px', fontWeight: 500, padding: '0.5rem 1.125rem'}}
                                        href={'https://www.hcrimaging.com/rna-cish'}
                                    >
                                        RNA-CISH
                                    </a>

                                    <a
                                        style={{fontSize: '18px', fontWeight: 500, padding: '0.5rem 1.125rem'}}
                                        href={'https://www.hcrimaging.com/rna-fish'}
                                    >
                                        RNA-FISH
                                    </a>
                                </div>

                                <div className={'right'}>

                                    <ShopLink to={AppPaths.LOCAL_NEW_KIT} navLink={true}>
                                        Shop
                                    </ShopLink>

                                    <NavLink to={AppPaths.CART}>Cart</NavLink>

                                    {!this.state.uiConfig.authenticated
                                        && <NavLink
                                            to={AppPaths.LOG_IN}>
                                            Account
                                        </NavLink>}

                                    {this.state.uiConfig.authenticated
                                        && <NavLink
                                            title={'Profile'}
                                            to={AppPaths.PROFILE}>
                                            Account
                                        </NavLink>}
                                </div>
                            </nav>
                        </header>

                        <div id="main">
                            <AppNav
                                uiConfig={this.state.uiConfig}
                                authnObserver={this.authnObserver}
                            />
                        </div>

                        <footer>
                            <div style={{
                                marginRight: 'auto',
                                marginLeft: 'auto',
                                maxWidth: '1280px',
                                width: '100%'
                            }}>
                                <div className={'footer-component'}>
                                    <a href={'https://www.molecularinstruments.com'} className={'mi-logo-wrapper'}>
                                        <img src={miLogo} alt={'mi-logo'} className={'mi-logo'}/>
                                    </a>

                                    <div className={'imagining-logo'}>
                                        <a href={'https://www.molecularinstruments.com'} style={{height: '39.77px'}}>
                                            <img src={imagingLogo} alt={'imaging-logo'} style={{width: '400px'}}/>
                                        </a>
                                    </div>

                                    <div className={'footer-column-3'}>

                                        <div>
                                            <a href={'https://www.linkedin.com/company/molecular-instruments/'}>
                                                <img
                                                    className={'footer-icon'}
                                                    src={linkedinIcon}
                                                    alt={'linkedin-icon'}
                                                />
                                            </a>

                                            <a href={'https://twitter.com/HCRimaging'}>
                                                <img
                                                    className={'footer-icon'}
                                                    src={twitterIcon}
                                                    alt={'twitter-icon'}
                                                />
                                            </a>

                                            <a href={'https://www.youtube.com/channel/UCAVNIdlGiCqYcvs9UwYKsKw'}>
                                                <img
                                                    className={'footer-icon'}
                                                    src={youtubeIcon}
                                                    alt={'youtube-icon'}
                                                />
                                            </a>
                                        </div>

                                        <div>
                                            <p style={{fontSize: '16px', fontWeight: 325, lineHeight: 1.5}}>Follow us
                                                on
                                                social media to hear all the latest
                                                updates</p>
                                        </div>

                                        <div style={{textAlign: 'left'}}>
                                            <div className={'footer-copyright-wrapper'}>
                                                <a className={'legal-link'}
                                                   href={"https://www.hcrimaging.com/legal/patents"}>Patents</a>
                                                <a className={'legal-link'}
                                                   href={"https://www.hcrimaging.com/legal/terms"}>Terms</a>
                                                <a className={'legal-link'}
                                                   href={"https://www.hcrimaging.com/legal/return-policy"}>Returns</a>
                                                <a className={'legal-link'}
                                                   href={"https://www.hcrimaging.com/legal/privacy-policy"}>Privacy</a>
                                                <a className={'legal-link'}
                                                   href={"https://www.hcrimaging.com/legal/fcoi"}>FCOI</a>
                                                <a className={'legal-link'} style={{marginRight: '0'}}
                                                   href={"https://www.hcrimaging.com/legal/safety"}>Safety</a>
                                                <p style={{
                                                    marginTop: '16px',
                                                    fontSize: '12px',
                                                    lineHeight: '1.25',
                                                    fontWeight: 325
                                                }}>
                                                    Copyright © {new Date().getFullYear()} Molecular Instruments, Inc. All
                                                    rights
                                                    reserved.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </footer>
                    </div>
                </Router>
            </UiConfigContext.Provider>
        </React.StrictMode>;
    }

    private readonly renderAllOrdersLink = () => {
        return <Link to={AppPaths.ADMIN_ORDERS}><Icon name={'boxes'}/>Orders</Link>
    };
    private readonly renderAllUsersLink = () => {
        return <Link to={AppPaths.ADMIN_USERS}><Icon name={'address book'}/>Users</Link>
    };
    private readonly renderTrackingLink = () => {
        return <Link to={AppPaths.ADMIN_TRACKING}><Icon name={'clipboard'}/>Tracking</Link>
    };
    private readonly renderReportsLink = () => {
        return <Link to={AppPaths.ADMIN_REPORTS}><Icon name={'chart bar'}/>Reports</Link>
    };
    private readonly renderRnaCatalogLink = () => {
        return <Link to={AppPaths.ADMIN_RNA_CATALOG}><Icon name={'book'}/>RNA Catalog</Link>
    };
    private readonly renderProbeLotTable = () => {
        return <Link to={AppPaths.ADMIN_PROBE_LOT_TABLE}><Icon name={'table'}/>Probe Lot Table</Link>
    }
    private readonly renderInventoryLink = () => {
        return <Link to={AppPaths.ADMIN_INVENTORY}><Icon name={'table'}/>Inventory</Link>
    }

    private readonly renderStarterKitsLink = () => {
        return <Link to={AppPaths.ADMIN_STARTER_KITS}><Icon name={'cart'}/>Starter Kits</Link>
    }
    private readonly renderReferralsLink = () => {
        return <Link to={AppPaths.MARKETING_REFERRALS}><Icon name={'ticket'}/>Marketing Referrals</Link>
    }

    private readonly renderAutomatedIfPresetReagentScalesLink = () => {
        return <Link to={AppPaths.AUTOMATED_GOLD_IF_PRESET_SCALES_PAGE}>Automated Gold If Scales</Link>
    }

    private readonly loadUiConfig = () => {
        getWithAuthn('/user/ui-config')
            .then((resp) => {
                return resp.json()
            })
            .then((r: UiConfigResponse) => {
                this.setState({
                    uiConfig: {
                        authenticated: r.userId !== undefined && r.userId !== null,
                        uiFeatures: new Set<string>(r.uiFeatures),
                        isDefault: false,
                        userStatus: r.legacy === "LEGACY" ? "LEGACY" : "NON_LEGACY",
                        academic: r.academic
                    },
                });

                // if we're unauthenticated, need to make sure this isn't falsely attributed to the wrong user,
                // and if we are authenticated, want to attribute. Not sure what unsetting user id does to the session,
                // but it seems like the only reasonable thing to do.
                const gaUserId = r.userId === null ? undefined : r.userId;
                gtag('config', GOOGLE_ANALYTICS_ID, {user_id: gaUserId});
            })
            .catch((rej) => {
                console.error(`Couldn't check authn state: ${rej}`)
            })
    }
}

interface AppNavProps {
    readonly uiConfig: UiConfig;
    readonly authnObserver: AuthnObserver,
}

// functional component so we can use useEffect to do our gtag
const AppNav = (navProps: AppNavProps) => {
    const admin = navProps.uiConfig.uiFeatures.has(FEATURE_SHOW_ADMIN_MENU);
    const reports = navProps.uiConfig.uiFeatures.has(FEATURE_REPORTS);
    const legacyUser = navProps.uiConfig.userStatus === "LEGACY"

    const redirectShop = () => <ShopRedirect/>;

    const redirectCish = () => <Redirect to={AppPaths.LOCAL_NEW_KIT_RNA_CISH}/>;

    const renderLogIn = (props: RouteComponentProps<any>) => {
        return <LogInPage
            authnObserver={navProps.authnObserver}
            authenticated={navProps.uiConfig.authenticated}
            routerProps={props}
        />;
    };
    const renderLogOut = () => {
        return <LogOutPage authnObserver={navProps.authnObserver}/>;
    };

    // Helper to be able to pass router props through
    const renderVerifyEmail = (props: RouterProps) => {
        return <VerifyEmailPage {...props}/>
    };
    const renderCart = (props: RouterProps) => {
        // we need to wait until the user config is done loading before we render the cart page.
        // Otherwise, we run into a problem where the wrong type of catalog is returned for cish.
        if (navProps.uiConfig.isDefault) {
            return <></>;
        }
        return <CartPage
            {...props}
            authenticated={navProps.uiConfig.authenticated}
            legacyUser={legacyUser}
        />
    };
    const renderResetPassword = (props: RouterProps) => {
        return <ResetPasswordPage {...props}/>
    };
    const renderOrderUploadPo = (props: RouterProps) => {
        return <OrderUploadPoPage {...props}/>
    };
    const renderAllOrders = (props: RouterProps) => {
        return <AllOrdersPage {...props}/>
    };
    const renderAllUsers = (props: RouterProps) => {
        return <AllUsersPage {...props}/>
    };
    const renderCishStarterKitPage = (props: RouterProps) => {
        return <ProStarterKitForm {...props}/>
    };
    const renderManualStarterKitPage = (props: RouterProps) => {
        return <ManualStarterKitForm {...props}/>
    };
    const renderReports = () => {
        return <ReportsPage/>
    };
    const renderConsumerCishPage = (props: RouterProps) => {
        return <NewMultiPlexProKitPage {...props} admin={admin}/>
    };
    const renderConsumerCishChromogenPage = () => {
        return <NewChromogenKitPage/>
    };

    // wire GA to nav changes
    const location = useLocation();

    // as per https://developers.google.com/analytics/devguides/collection/gtagjs/single-page-applications
    React.useEffect(() => {
        gtag('config', GOOGLE_ANALYTICS_ID, {'page_path': location.pathname});
    }, [location]);

    return <Switch>
        <Route exact={true} path='/' render={redirectShop}/>
        <Route exact={true} path={'/new-kit/rna-cish'} render={redirectCish}/>

        <Route exact={true} path={AppPaths.LOCAL_NEW_KIT}><NewKitPage/></Route>
        <Route path={AppPaths.CART} render={renderCart}/>
        <Route exact={true} path={AppPaths.REGISTER}><NewRegistrationPage/></Route>
        <Route exact={true} path={AppPaths.NEW_REGISTER_PREVIEW}><NewRegistrationPage/></Route>
        <Route path={AppPaths.LOG_IN} render={renderLogIn}/>
        <Route path={AppPaths.ORDERS} component={UserOrderListPage}/>
        <Route path={AppPaths.ORDER_PATTERN} component={UserOrderPage}/>
        <Route path={AppPaths.PROFILE}><ProfilePage/></Route>
        <Route path={AppPaths.LOG_OUT} render={renderLogOut}/>
        <Route path={'/user/verify-email'} render={renderVerifyEmail}/>
        <Route path={'/user/reset-password'} render={renderResetPassword}/>
        <Route path={AppPaths.ORDER_UPLOAD_PO} render={renderOrderUploadPo}/>
        <Route path={AppPaths.LOCAL_NEW_KIT_RNA_CISH} render={renderConsumerCishPage}/>
        <Route path={AppPaths.LOCAL_NEW_KIT_RNA_CISH_CHROMOGEN} render={renderConsumerCishChromogenPage}/>

        {admin &&
            <Route path={AppPaths.LOCAL_NEW_LEGACY_KIT_RNA_FISH}><NewRnaFishKitPage legacy={true} adminUser={admin} legacyUser={legacyUser}/></Route>}
        {admin && <Route path={AppPaths.LOCAL_NEW_KIT_RNA_FISH}><NewRnaFishKitPage legacy={false} adminUser={admin} legacyUser={legacyUser}/></Route>}
        {admin && <Route path={AppPaths.LOCAL_NEW_KIT_MANUAL_PRO}><NewManualProConsumerKitPage adminUser={admin}/></Route>}
        {admin && <Route path={AppPaths.LOCAL_NEW_KIT_ENCODER}><NewManualGoldIfKitPage adminUser={admin}/></Route>}
        {admin && <Route path={AppPaths.LOCAL_NEW_KIT_IHC2}><NewSecondaryIfKitPage legacy={false} adminUser={admin} legacyUser={legacyUser}/></Route>}
        {admin && <Route path={AppPaths.LOCAL_NEW_LEGACY_KIT_IHC2}><NewSecondaryIfKitPage legacy={true} adminUser={admin} legacyUser={legacyUser}/></Route>}
        {admin && <Route path={AppPaths.ADMIN_ORDERS} render={renderAllOrders}/>}
        {admin && <Route path={AppPaths.ADMIN_ORDER_PATTERN} component={SingleOrderPage}/>}
        {admin && <Route path={AppPaths.ADMIN_USERS} render={renderAllUsers}/>}
        {admin && <Route path={AppPaths.ADMIN_USER_PATTERN} component={SingleUserPage}/>}
        {admin && <Route path={AppPaths.ADMIN_TRACKING}><TrackingPage/></Route>}
        {admin && <Route path={AppPaths.ADMIN_RNA_CATALOG}><RnaCatalogPage/></Route>}
        {admin && <Route path={AppPaths.ADMIN_PROBE_LOT_TABLE}><ProbeLotTablePage/></Route>}
        {admin && <Route path={AppPaths.ADMIN_INVENTORY}><InventoryPage/></Route>}
        {admin && <Route path={AppPaths.ADMIN_FLUORESCENT_HAIRPIN_TRACKING}><FluorescentHairpinTrackingPage/></Route>}
        {admin && <Route path={AppPaths.ADMIN_MANUAL_BUFFER_TRACKING}><ManualBufferTrackingPage/></Route>}
        {admin && <Route path={AppPaths.ADMIN_ENCODER_TRACKING}><EncoderTrackingPage/></Route>}
        {admin && <Route path={AppPaths.ADMIN_SECONDARY_IF_PROBE_TRACKING}><SecondaryIfProbeTrackingPage/></Route>}
        {admin && <Route path={AppPaths.ADMIN_PRO_DETECT_TRACKING}><ProDetectTrackingPage/></Route>}
        {admin && <Route path={AppPaths.ADMIN_STARTER_KITS}><StarterKitsPage/></Route>}
        {admin && <Route path={AppPaths.ADMIN_RNA_CISH_STARTER_KIT} render={renderCishStarterKitPage}/>}
        {admin && <Route path={AppPaths.ADMIN_MANUAL_STARTER_KIT} render={renderManualStarterKitPage}/>}
        {admin && reports && <Route path={AppPaths.ADMIN_REPORTS} render={renderReports}/>}
        {admin && <Route path={AppPaths.MARKETING_REFERRALS}><MarketingReferralsPage/></Route>}
        {admin && <Route path={AppPaths.AUTOMATED_GOLD_IF_PRESET_SCALES_PAGE}><AutomatedIfPresetScalesPage/></Route>}
    </Switch>
};

export default App;

interface AppState {
    readonly uiConfig: UiConfig,
}

interface UiConfigResponse {
    readonly userId?: string,
    readonly uiFeatures: string[],
    readonly legacy: string,
    readonly academic: boolean
}

const FEATURE_SHOW_ADMIN_MENU = 'showAdminMenu';
const FEATURE_REPORTS = 'adminReports';



// WEBPACK FOOTER //
// ./src/App.tsx